export default {
    actions: {
        loadServerStats() {
            return this.dispatch('sendRequest', { path: '/system/stats', method: 'get', formErrors: {} });
        }
    }
}
